(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["peachy-gum-flavors-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.peachyGumFlavorsGridScrollInit) return;
    window.peachyGumFlavorsGridScrollInit = true;

    var PRODUCT_INFO_SELECTORS = 'product-info, #product-info, [id^="ProductInfo-"], .product-info-main';

    function prefersReducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function headerOffset() {
      var value = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
      var parsed = parseFloat(value);
      return Number.isFinite(parsed) ? parsed : 0;
    }

    function findProductInfo() {
      return document.querySelector(PRODUCT_INFO_SELECTORS);
    }

    function scrollToProductInfo(event) {
      var target = findProductInfo();
      if (!target) return;

      event.preventDefault();

      var top = target.getBoundingClientRect().top + window.scrollY - headerOffset();
      window.scrollTo({
        top: Math.max(0, top),
        behavior: prefersReducedMotion() ? 'auto' : 'smooth'
      });
    }

    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-peachy-gum-flavors-scroll]');
      if (!button) return;
      scrollToProductInfo(event);
    });

    function flavorTexts() {
      return document.querySelectorAll('.peachy-gum-flavors-grid__flavor-text');
    }

    function truncateFlavorText(el) {
      var original = el.getAttribute('data-original-text');
      if (!original) {
        original = (el.textContent || '').replace(/\s+/g, ' ').trim();
        el.setAttribute('data-original-text', original);
      }

      if (window.matchMedia('(min-width: 1300px)').matches) {
        el.textContent = original;
        return;
      }

      el.textContent = original;
      if (el.scrollWidth <= el.clientWidth + 1) return;

      var words = original.split(' ');
      var fit = 0;
      var low = 1;
      var high = words.length;

      while (low <= high) {
        var mid = (low + high) >> 1;
        el.textContent = words.slice(0, mid).join(' ') + '…';
        if (el.scrollWidth <= el.clientWidth + 1) {
          fit = mid;
          low = mid + 1;
        } else {
          high = mid - 1;
        }
      }

      el.textContent = fit > 0 ? words.slice(0, fit).join(' ') + '…' : '…';
    }

    function truncateAllFlavorTexts() {
      flavorTexts().forEach(truncateFlavorText);
    }

    var resizeTimer = null;
    function onResize() {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(truncateAllFlavorTexts, 80);
    }

    window.addEventListener('resize', onResize);
    document.addEventListener('shopify:section:load', truncateAllFlavorTexts);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', truncateAllFlavorTexts);
    } else {
      truncateAllFlavorTexts();
    }

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(truncateAllFlavorTexts);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["peachy-how-to-use"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var instances = new WeakMap();

    function cards(root) {
      return Array.prototype.slice.call(root.querySelectorAll('[data-peachy-how-to-use-card]'));
    }

    function dots(root) {
      return Array.prototype.slice.call(root.querySelectorAll('[data-peachy-how-to-use-dot]'));
    }

    function nearestIndex(scroller, items) {
      var scrollerLeft = scroller.getBoundingClientRect().left;
      var nearest = 0;
      var nearestDist = Infinity;

      items.forEach(function (card, index) {
        var dist = Math.abs(card.getBoundingClientRect().left - scrollerLeft);
        if (dist < nearestDist) {
          nearestDist = dist;
          nearest = index;
        }
      });

      return nearest;
    }

    function scrollToCard(scroller, card) {
      var delta = card.getBoundingClientRect().left - scroller.getBoundingClientRect().left;
      scroller.scrollTo({
        left: scroller.scrollLeft + delta,
        behavior: 'smooth'
      });
    }

    function sync(root) {
      var scroller = root.querySelector('[data-peachy-how-to-use-scroller]');
      var pagination = root.querySelector('[data-peachy-how-to-use-dots]');
      if (!scroller) return;

      var items = cards(root);
      var overflow = scroller.scrollWidth > scroller.clientWidth + 1;
      root.classList.toggle('peachy-how-to-use--has-overflow', overflow);

      if (pagination) {
        pagination.hidden = !overflow;
      }

      if (!overflow) return;

      var active = nearestIndex(scroller, items);
      dots(root).forEach(function (dot, index) {
        var isActive = index === active;
        dot.classList.toggle('is-active', isActive);
        if (isActive) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    }

    function destroy(root) {
      var state = instances.get(root);
      if (!state) return;

      if (state.resizeObserver) state.resizeObserver.disconnect();
      if (state.scroller && state.onScroll) {
        state.scroller.removeEventListener('scroll', state.onScroll);
      }
      state.unbindDots.forEach(function (unbind) {
        unbind();
      });
      instances.delete(root);
    }

    function initialize(root) {
      if (!root) return;

      destroy(root);

      var scroller = root.querySelector('[data-peachy-how-to-use-scroller]');
      if (!scroller) return;

      var items = cards(root);
      var unbindDots = dots(root).map(function (dot, index) {
        var onClick = function () {
          var card = items[index];
          if (!card) return;
          scrollToCard(scroller, card);
        };
        dot.addEventListener('click', onClick);
        return function () {
          dot.removeEventListener('click', onClick);
        };
      });

      var onScroll = function () {
        sync(root);
      };

      scroller.addEventListener('scroll', onScroll, { passive: true });

      var resizeObserver = null;
      if (typeof ResizeObserver === 'function') {
        resizeObserver = new ResizeObserver(function () {
          sync(root);
        });
        resizeObserver.observe(scroller);
        if (scroller.firstElementChild) resizeObserver.observe(scroller.firstElementChild);
      }

      instances.set(root, {
        scroller: scroller,
        onScroll: onScroll,
        resizeObserver: resizeObserver,
        unbindDots: unbindDots
      });

      sync(root);
    }

    function initializeAll(scope) {
      var root = scope || document;
      if (root.matches && root.matches('[data-peachy-how-to-use]')) initialize(root);
      if (!root.querySelectorAll) return;
      root.querySelectorAll('[data-peachy-how-to-use]').forEach(initialize);
    }

    document.addEventListener('shopify:section:load', function (event) {
      initializeAll(event.target);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      var root = event.target.querySelector('[data-peachy-how-to-use]');
      if (!root && event.target.matches && event.target.matches('[data-peachy-how-to-use]')) {
        root = event.target;
      }
      if (root) destroy(root);
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initializeAll();
      });
    } else {
      initializeAll();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["peachy-journey"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.larineJourneyInit) return;
    window.larineJourneyInit = true;

    var PRODUCT_INFO_SELECTORS = 'product-info, #product-info, [id^="ProductInfo-"], .product-info-main';
    var ticking = false;

    function prefersReducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function headerOffset() {
      var value = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
      var parsed = parseFloat(value);
      return Number.isFinite(parsed) ? parsed : 0;
    }

    function findProductInfo() {
      return document.querySelector(PRODUCT_INFO_SELECTORS);
    }

    function scrollToProductInfo(event) {
      var target = findProductInfo();
      if (!target) return;

      event.preventDefault();

      var top = target.getBoundingClientRect().top + window.scrollY - headerOffset();
      window.scrollTo({
        top: Math.max(0, top),
        behavior: prefersReducedMotion() ? 'auto' : 'smooth'
      });
    }

    function updateTimeline(root) {
      var timeline = root.querySelector('[data-journey-timeline]');
      if (!timeline) return;

      var steps = Array.prototype.slice.call(timeline.querySelectorAll('[data-journey-step]'));
      var progress = timeline.querySelector('[data-journey-progress]');
      var track = timeline.querySelector('.journey__track');
      if (!steps.length || !progress || !track) return;

      var firstDot = steps[0].querySelector('.journey__dot');
      var lastDot = steps[steps.length - 1].querySelector('.journey__dot');
      if (!firstDot || !lastDot) return;

      var timelineRect = timeline.getBoundingClientRect();
      var firstRect = firstDot.getBoundingClientRect();
      var lastRect = lastDot.getBoundingClientRect();
      var startOffset = firstRect.top + firstRect.height / 2 - timelineRect.top;
      var endOffset = lastRect.top + lastRect.height / 2 - timelineRect.top;

      track.style.top = startOffset + 'px';
      track.style.height = Math.max(endOffset - startOffset, 0) + 'px';

      if (prefersReducedMotion()) {
        root.classList.add('journey--reduced');
        steps.forEach(function (step) {
          step.classList.add('is-active');
        });
        progress.style.height = '100%';
        return;
      }

      var viewportTrigger = window.innerHeight * 0.55;
      var start = firstRect.top + firstRect.height / 2;
      var end = lastRect.top + lastRect.height / 2;
      var fill = Math.min(1, Math.max(0, (viewportTrigger - start) / Math.max(end - start, 1)));

      progress.style.height = fill * 100 + '%';

      steps.forEach(function (step) {
        var dot = step.querySelector('.journey__dot');
        if (!dot) return;
        var dotRect = dot.getBoundingClientRect();
        step.classList.toggle('is-active', dotRect.top + dotRect.height / 2 <= viewportTrigger);
      });
    }

    function updateAll() {
      document.querySelectorAll('[data-journey]').forEach(updateTimeline);
    }

    function onScrollOrResize() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        updateAll();
        ticking = false;
      });
    }

    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-journey-scroll]');
      if (!button) return;
      scrollToProductInfo(event);
    });

    document.addEventListener('shopify:section:load', updateAll);
    window.addEventListener('scroll', onScrollOrResize, { passive: true });
    window.addEventListener('resize', onScrollOrResize);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', updateAll);
    } else {
      updateAll();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["peachy-pr-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__peachyPrCarouselInit) return;
    window.__peachyPrCarouselInit = true;

    var instances = new WeakMap();

    function cards(root) {
      return Array.prototype.slice.call(root.querySelectorAll('[data-peachy-pr-carousel-card]'));
    }

    function dots(root) {
      return Array.prototype.slice.call(root.querySelectorAll('[data-peachy-pr-carousel-dot]'));
    }

    function nearestIndex(scroller, items) {
      var scrollerLeft = scroller.getBoundingClientRect().left;
      var nearest = 0;
      var nearestDist = Infinity;

      items.forEach(function (card, index) {
        var dist = Math.abs(card.getBoundingClientRect().left - scrollerLeft);
        if (dist < nearestDist) {
          nearestDist = dist;
          nearest = index;
        }
      });

      return nearest;
    }

    function scrollToCard(scroller, card) {
      var delta = card.getBoundingClientRect().left - scroller.getBoundingClientRect().left;
      scroller.scrollTo({
        left: scroller.scrollLeft + delta,
        behavior: 'smooth'
      });
    }

    function sync(root) {
      var scroller = root.querySelector('[data-peachy-pr-carousel-scroller]');
      var pagination = root.querySelector('[data-peachy-pr-carousel-dots]');
      var prev = root.querySelector('[data-peachy-pr-carousel-prev]');
      var next = root.querySelector('[data-peachy-pr-carousel-next]');
      if (!scroller) return;

      var items = cards(root);
      var overflow = scroller.scrollWidth > scroller.clientWidth + 1;
      root.classList.toggle('peachy-pr-carousel--has-overflow', overflow);

      if (pagination) pagination.hidden = !overflow;
      if (prev) prev.hidden = !overflow;
      if (next) next.hidden = !overflow;
      if (!overflow || !items.length) return;

      var active = nearestIndex(scroller, items);
      var atStart = scroller.scrollLeft <= 1;
      var atEnd = scroller.scrollLeft + scroller.clientWidth >= scroller.scrollWidth - 1;

      if (prev) prev.disabled = atStart;
      if (next) next.disabled = atEnd;

      dots(root).forEach(function (dot, index) {
        var isActive = index === active;
        dot.classList.toggle('is-active', isActive);
        if (isActive) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    }

    function destroy(root) {
      var state = instances.get(root);
      if (!state) return;
      if (state.resizeObserver) state.resizeObserver.disconnect();
      if (state.scroller && state.onScroll) state.scroller.removeEventListener('scroll', state.onScroll);
      state.unbind.forEach(function (unbind) { unbind(); });
      instances.delete(root);
    }

    function initialize(root) {
      if (!root) return;
      destroy(root);

      var scroller = root.querySelector('[data-peachy-pr-carousel-scroller]');
      if (!scroller) return;

      var items = cards(root);
      var unbind = [];

      dots(root).forEach(function (dot, index) {
        var onClick = function () {
          if (items[index]) scrollToCard(scroller, items[index]);
        };
        dot.addEventListener('click', onClick);
        unbind.push(function () { dot.removeEventListener('click', onClick); });
      });

      var prev = root.querySelector('[data-peachy-pr-carousel-prev]');
      var next = root.querySelector('[data-peachy-pr-carousel-next]');

      if (prev) {
        var onPrev = function () {
          var index = nearestIndex(scroller, items);
          if (items[index - 1]) scrollToCard(scroller, items[index - 1]);
        };
        prev.addEventListener('click', onPrev);
        unbind.push(function () { prev.removeEventListener('click', onPrev); });
      }

      if (next) {
        var onNext = function () {
          var index = nearestIndex(scroller, items);
          if (items[index + 1]) scrollToCard(scroller, items[index + 1]);
        };
        next.addEventListener('click', onNext);
        unbind.push(function () { next.removeEventListener('click', onNext); });
      }

      var onScroll = function () { sync(root); };
      scroller.addEventListener('scroll', onScroll, { passive: true });

      var resizeObserver = null;
      if (typeof ResizeObserver === 'function') {
        resizeObserver = new ResizeObserver(function () { sync(root); });
        resizeObserver.observe(scroller);
        if (scroller.firstElementChild) resizeObserver.observe(scroller.firstElementChild);
      }

      instances.set(root, {
        scroller: scroller,
        onScroll: onScroll,
        resizeObserver: resizeObserver,
        unbind: unbind
      });

      sync(root);
    }

    function initializeAll(scope) {
      var root = scope || document;
      if (root.matches && root.matches('[data-peachy-pr-carousel]')) initialize(root);
      if (!root.querySelectorAll) return;
      root.querySelectorAll('[data-peachy-pr-carousel]').forEach(initialize);
    }

    document.addEventListener('shopify:section:load', function (event) {
      initializeAll(event.target);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      var root = event.target.querySelector('[data-peachy-pr-carousel]');
      if (!root && event.target.matches && event.target.matches('[data-peachy-pr-carousel]')) root = event.target;
      if (root) destroy(root);
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initializeAll(); });
    } else {
      initializeAll();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["peachy-reasons"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.larinePeachyReasonsInit) return;
    window.larinePeachyReasonsInit = true;

    var instances = new Map();

    function stripClones(el) {
      el.querySelectorAll('[data-peachy-reasons-clone]').forEach(function (node) {
        node.remove();
      });
    }

    function cloneSlide(slide) {
      var clone = slide.cloneNode(true);
      clone.setAttribute('data-peachy-reasons-clone', 'true');
      clone.removeAttribute('data-shopify-editor-block');
      return clone;
    }

    function prepareLoopSlides(el) {
      stripClones(el);

      var wrapper = el.querySelector('.swiper-wrapper');
      if (!wrapper) return 0;

      var originals = Array.prototype.filter.call(wrapper.children, function (node) {
        return node.classList && node.classList.contains('swiper-slide');
      });
      var count = originals.length;
      if (count < 2) return count;

      originals.forEach(function (slide) {
        wrapper.appendChild(cloneSlide(slide));
      });

      for (var index = originals.length - 1; index >= 0; index--) {
        wrapper.insertBefore(cloneSlide(originals[index]), wrapper.firstChild);
      }

      return count;
    }

    function realIndex(swiper, count) {
      return ((swiper.activeIndex % count) + count) % count;
    }

    function syncPagination(pagination, swiper, count) {
      if (!pagination) return;

      var active = realIndex(swiper, count);
      Array.prototype.forEach.call(pagination.children, function (bullet, index) {
        var isActive = index === active;
        bullet.classList.toggle('swiper-pagination-bullet-active', isActive);
        bullet.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
    }

    function renderPagination(pagination, swiper, count) {
      if (!pagination) return;

      pagination.innerHTML = '';

      for (var index = 0; index < count; index++) {
        var bullet = document.createElement('button');
        bullet.type = 'button';
        bullet.className = 'swiper-pagination-bullet';
        bullet.setAttribute('aria-label', 'Go to slide ' + (index + 1));
        bullet.addEventListener('click', function (targetIndex) {
          return function () {
            swiper.slideTo(count + targetIndex);
          };
        }(index));
        pagination.appendChild(bullet);
      }

      syncPagination(pagination, swiper, count);
    }

    function normalizeLoop(swiper, count, pagination) {
      if (swiper.activeIndex < count) {
        swiper.slideTo(swiper.activeIndex + count, 0, false);
      } else if (swiper.activeIndex >= count * 2) {
        swiper.slideTo(swiper.activeIndex - count, 0, false);
      }

      syncPagination(pagination, swiper, count);
    }

    function destroy(root) {
      var instance = instances.get(root);
      var el = root.querySelector('[data-peachy-reasons-swiper]');

      if (instance) {
        instance.destroy(true, true);
        instances.delete(root);
      }

      if (el) stripClones(el);
    }

    function initialize(root) {
      if (!root || typeof window.Swiper !== 'function') return;

      var el = root.querySelector('[data-peachy-reasons-swiper]');
      if (!el) return;

      destroy(root);

      var count = prepareLoopSlides(el);
      var prev = root.querySelector('[data-peachy-reasons-prev]');
      var next = root.querySelector('[data-peachy-reasons-next]');
      var pagination = root.querySelector('[data-peachy-reasons-pagination]');
      var enableLoop = count > 1;

      var swiper = new window.Swiper(el, {
        slidesPerView: 'auto',
        spaceBetween: 16,
        speed: 450,
        loop: false,
        rewind: false,
        initialSlide: enableLoop ? count : 0,
        watchOverflow: false,
        grabCursor: enableLoop,
        allowTouchMove: true,
        navigation: prev && next ? {
          prevEl: prev,
          nextEl: next
        } : undefined,
        breakpoints: {
          1300: {
            spaceBetween: 20
          }
        },
        on: {
          init: function () {
            if (enableLoop) renderPagination(pagination, this, count);
          },
          slideChange: function () {
            if (enableLoop) syncPagination(pagination, this, count);
          },
          transitionEnd: function () {
            if (enableLoop) normalizeLoop(this, count, pagination);
          }
        }
      });

      instances.set(root, swiper);
    }

    function initializeAll(scope) {
      var root = scope || document;
      if (root.matches && root.matches('[data-peachy-reasons]')) initialize(root);
      if (!root.querySelectorAll) return;
      root.querySelectorAll('[data-peachy-reasons]').forEach(initialize);
    }

    document.addEventListener('shopify:section:load', function (event) {
      initializeAll(event.target);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      var root = event.target.querySelector('[data-peachy-reasons]') || (event.target.matches && event.target.matches('[data-peachy-reasons]') ? event.target : null);
      if (root) destroy(root);
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initializeAll();
      });
    } else {
      initializeAll();
    }

    document.addEventListener('larine:swiper', function () {
      initializeAll();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["peachy-testimonials"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.larinePeachyTestimonialsInit) return;
    window.larinePeachyTestimonialsInit = true;

    var instances = new Map();

    function stripClones(el) {
      el.querySelectorAll('[data-peachy-testimonials-clone]').forEach(function (node) {
        node.remove();
      });
    }

    function cloneSlide(slide) {
      var clone = slide.cloneNode(true);
      clone.setAttribute('data-peachy-testimonials-clone', 'true');
      clone.removeAttribute('data-shopify-editor-block');
      return clone;
    }

    function prepareLoopSlides(el) {
      stripClones(el);

      var wrapper = el.querySelector('.swiper-wrapper');
      if (!wrapper) return 0;

      var originals = Array.prototype.filter.call(wrapper.children, function (node) {
        return node.classList && node.classList.contains('swiper-slide');
      });
      var count = originals.length;
      if (count < 2) return count;

      originals.forEach(function (slide) {
        wrapper.appendChild(cloneSlide(slide));
      });

      for (var index = originals.length - 1; index >= 0; index--) {
        wrapper.insertBefore(cloneSlide(originals[index]), wrapper.firstChild);
      }

      return count;
    }

    function realIndex(swiper, count) {
      return ((swiper.activeIndex % count) + count) % count;
    }

    function syncPagination(pagination, swiper, count) {
      if (!pagination) return;

      var active = realIndex(swiper, count);
      Array.prototype.forEach.call(pagination.children, function (bullet, index) {
        var isActive = index === active;
        bullet.classList.toggle('swiper-pagination-bullet-active', isActive);
        bullet.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
    }

    function renderPagination(pagination, swiper, count) {
      if (!pagination) return;

      pagination.innerHTML = '';

      for (var index = 0; index < count; index++) {
        var bullet = document.createElement('button');
        bullet.type = 'button';
        bullet.className = 'swiper-pagination-bullet';
        bullet.setAttribute('aria-label', 'Go to slide ' + (index + 1));
        bullet.addEventListener('click', function (targetIndex) {
          return function () {
            swiper.slideTo(count + targetIndex);
          };
        }(index));
        pagination.appendChild(bullet);
      }

      syncPagination(pagination, swiper, count);
    }

    function normalizeLoop(swiper, count, pagination) {
      if (swiper.activeIndex < count) {
        swiper.slideTo(swiper.activeIndex + count, 0, false);
      } else if (swiper.activeIndex >= count * 2) {
        swiper.slideTo(swiper.activeIndex - count, 0, false);
      }

      syncPagination(pagination, swiper, count);
    }

    function destroy(root) {
      var instance = instances.get(root);
      var el = root.querySelector('[data-peachy-testimonials-swiper]');

      if (instance) {
        instance.destroy(true, true);
        instances.delete(root);
      }

      if (el) stripClones(el);
    }

    function initialize(root) {
      if (!root || typeof window.Swiper !== 'function') return;

      var el = root.querySelector('[data-peachy-testimonials-swiper]');
      if (!el) return;

      destroy(root);

      var count = prepareLoopSlides(el);
      var prev = root.querySelector('[data-peachy-testimonials-prev]');
      var next = root.querySelector('[data-peachy-testimonials-next]');
      var pagination = root.querySelector('[data-peachy-testimonials-pagination]');
      var enableLoop = count > 1;

      var swiper = new window.Swiper(el, {
        slidesPerView: 'auto',
        spaceBetween: 16,
        speed: 450,
        loop: false,
        rewind: false,
        initialSlide: enableLoop ? count : 0,
        watchOverflow: false,
        grabCursor: enableLoop,
        allowTouchMove: true,
        navigation: prev && next ? {
          prevEl: prev,
          nextEl: next
        } : undefined,
        on: {
          init: function () {
            if (enableLoop) renderPagination(pagination, this, count);
          },
          slideChange: function () {
            if (enableLoop) syncPagination(pagination, this, count);
          },
          transitionEnd: function () {
            if (enableLoop) normalizeLoop(this, count, pagination);
          }
        }
      });

      instances.set(root, swiper);
    }

    function initializeAll(scope) {
      var root = scope || document;
      if (root.matches && root.matches('[data-peachy-testimonials]')) initialize(root);
      if (!root.querySelectorAll) return;
      root.querySelectorAll('[data-peachy-testimonials]').forEach(initialize);
    }

    document.addEventListener('shopify:section:load', function (event) {
      initializeAll(event.target);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      var root = event.target.querySelector('[data-peachy-testimonials]') || (event.target.matches && event.target.matches('[data-peachy-testimonials]') ? event.target : null);
      if (root) destroy(root);
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initializeAll();
      });
    } else {
      initializeAll();
    }

    document.addEventListener('larine:swiper', function () {
      initializeAll();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["peachy-whats-inside"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.larineWhatsInsideInit) return;
    window.larineWhatsInsideInit = true;

    var instances = new Map();

    function stripClones(el) {
      el.querySelectorAll('[data-whats-inside-clone]').forEach(function (node) {
        node.remove();
      });
    }

    function cloneSlide(slide) {
      var clone = slide.cloneNode(true);
      clone.setAttribute('data-whats-inside-clone', 'true');
      clone.removeAttribute('data-shopify-editor-block');
      return clone;
    }

    function prepareLoopSlides(el) {
      stripClones(el);

      var wrapper = el.querySelector('.swiper-wrapper');
      if (!wrapper) return 0;

      var originals = Array.prototype.filter.call(wrapper.children, function (node) {
        return node.classList && node.classList.contains('swiper-slide');
      });
      var count = originals.length;
      if (count < 2) return count;

      originals.forEach(function (slide) {
        wrapper.appendChild(cloneSlide(slide));
      });

      for (var index = originals.length - 1; index >= 0; index--) {
        wrapper.insertBefore(cloneSlide(originals[index]), wrapper.firstChild);
      }

      return count;
    }

    function realIndex(swiper, count) {
      return ((swiper.activeIndex % count) + count) % count;
    }

    function syncPagination(pagination, swiper, count) {
      if (!pagination) return;

      var active = realIndex(swiper, count);
      Array.prototype.forEach.call(pagination.children, function (bullet, index) {
        var isActive = index === active;
        bullet.classList.toggle('swiper-pagination-bullet-active', isActive);
        bullet.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
    }

    function renderPagination(pagination, swiper, count) {
      if (!pagination) return;

      pagination.innerHTML = '';

      for (var index = 0; index < count; index++) {
        var bullet = document.createElement('button');
        bullet.type = 'button';
        bullet.className = 'swiper-pagination-bullet';
        bullet.setAttribute('aria-label', 'Go to slide ' + (index + 1));
        bullet.addEventListener('click', function (targetIndex) {
          return function () {
            swiper.slideTo(count + targetIndex);
          };
        }(index));
        pagination.appendChild(bullet);
      }

      syncPagination(pagination, swiper, count);
    }

    function normalizeLoop(swiper, count, pagination) {
      if (swiper.activeIndex < count) {
        swiper.slideTo(swiper.activeIndex + count, 0, false);
      } else if (swiper.activeIndex >= count * 2) {
        swiper.slideTo(swiper.activeIndex - count, 0, false);
      }

      syncPagination(pagination, swiper, count);
    }

    function destroy(root) {
      var instance = instances.get(root);
      var el = root.querySelector('[data-whats-inside-swiper]');

      if (instance) {
        instance.destroy(true, true);
        instances.delete(root);
      }

      if (el) stripClones(el);
    }

    function initialize(root) {
      if (!root || typeof window.Swiper !== 'function') return;

      var el = root.querySelector('[data-whats-inside-swiper]');
      if (!el) return;

      destroy(root);

      var count = prepareLoopSlides(el);
      var prev = root.querySelector('[data-whats-inside-prev]');
      var next = root.querySelector('[data-whats-inside-next]');
      var pagination = root.querySelector('[data-whats-inside-pagination]');
      var enableLoop = count > 1;

      var swiper = new window.Swiper(el, {
        slidesPerView: 'auto',
        spaceBetween: 16,
        speed: 450,
        loop: false,
        rewind: false,
        initialSlide: enableLoop ? count : 0,
        watchOverflow: false,
        grabCursor: enableLoop,
        allowTouchMove: true,
        navigation: prev && next ? {
          prevEl: prev,
          nextEl: next
        } : undefined,
        breakpoints: {
          990: {
            spaceBetween: 17
          }
        },
        on: {
          init: function () {
            if (enableLoop) renderPagination(pagination, this, count);
          },
          slideChange: function () {
            if (enableLoop) syncPagination(pagination, this, count);
          },
          transitionEnd: function () {
            if (enableLoop) normalizeLoop(this, count, pagination);
          }
        }
      });

      instances.set(root, swiper);
    }

    function initializeAll(scope) {
      var root = scope || document;
      if (root.matches && root.matches('[data-whats-inside]')) initialize(root);
      if (!root.querySelectorAll) return;
      root.querySelectorAll('[data-whats-inside]').forEach(initialize);
    }

    document.addEventListener('shopify:section:load', function (event) {
      initializeAll(event.target);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      var root = event.target.querySelector('[data-whats-inside]') || (event.target.matches && event.target.matches('[data-whats-inside]') ? event.target : null);
      if (root) destroy(root);
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initializeAll();
      });
    } else {
      initializeAll();
    }

    document.addEventListener('larine:swiper', function () {
      initializeAll();
    });

    window.addEventListener('resize', function () {
      document.querySelectorAll('[data-whats-inside]').forEach(function (root) {
        if (!instances.get(root)) initialize(root);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["unable-to-leave-footer"] && !Shopify.designMode) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();
})();
